/**
 * 密码条目卡片
 * 显示站点图标、名称、账号、密码强度
 * 支持一键复制账号/密码
 */

import React from "react";
import type { DecryptedItem } from "@passkeeper/shared";
import { CATEGORY_NAMES } from "@passkeeper/shared";
import { useStore } from "../store";

interface Props {
  item: DecryptedItem;
  showToast: (msg: string, type: "success" | "error" | "info") => void;
}

export default function ItemCard({ item, showToast }: Props) {
  const setViewingItem = useStore((s) => s.setViewingItem);

  const copyToClipboard = async (text: string, label: string) => {
    try {
      await navigator.clipboard.writeText(text);
      showToast(`${label} 已复制`, "success");
    } catch {
      showToast("复制失败", "error");
    }
  };

  const isEncrypted = item.username.includes("🔒");

  const strengthClass = `strength-bar strength-${item.strength}`;
  const categoryClass = `category-badge category-${item.category}`;

  return (
    <div className="item-card" onClick={() => !isEncrypted && setViewingItem(item)}>
      {/* 头部：图标 + 标题 */}
      <div className="item-header">
        <div className="item-favicon">
          {item.favicon ? (
            <img src={item.favicon} alt="" width="32" height="32" />
          ) : (
            <span>🔐</span>
          )}
        </div>
        <div style={{ flex: 1, minWidth: 0 }}>
          <div className="item-title">{item.title}</div>
          <div className="item-domain">{item.domain || item.url}</div>
        </div>
        <span className={categoryClass}>{CATEGORY_NAMES[item.category]}</span>
      </div>

      {/* 账号 */}
      <div className="item-username">{item.username}</div>

      {/* 密码强度 */}
      <div className={strengthClass} />

      {/* 操作按钮 */}
      <div className="item-actions" onClick={(e) => e.stopPropagation()}>
        <button
          className="btn btn-ghost btn-sm"
          onClick={() => copyToClipboard(item.username, "账号")}
          disabled={isEncrypted}
        >
          📋 账号
        </button>
        <button
          className="btn btn-ghost btn-sm"
          onClick={() => copyToClipboard(item.password, "密码")}
          disabled={isEncrypted}
        >
          📋 密码
        </button>
        <button
          className="btn btn-ghost btn-sm"
          onClick={() => !isEncrypted && setViewingItem(item)}
          disabled={isEncrypted}
        >
          👁 查看
        </button>
      </div>
    </div>
  );
}